import { Plug } from "lucide-react";

/** Integrações (WhatsApp, Google Agenda, pagamentos) — ainda não existem; a seção avisa. */
export function EmBreveSecao() {
  return (
    <div className="flex flex-col items-center gap-2 px-6 py-14 text-center">
      <Plug className="h-8 w-8 text-zinc-300" />
      <p className="text-sm font-semibold text-zinc-900 dark:text-foreground">Em breve</p>
      <p className="max-w-sm text-[12.5px] text-zinc-500 dark:text-muted-foreground">
        Conectar WhatsApp, Google Agenda e meios de pagamento à organização.
      </p>
    </div>
  );
}
